/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Счётчики уведомлений пользователя по признаку прочтения (без учёта фильтра notificationType)
 * @export
 * @interface NotificationCounts
 */
export interface NotificationCounts {
  /**
   * Прочитанные
   * @type {number}
   * @memberof NotificationCounts
   */
  read: number
  /**
   * Непрочитанные
   * @type {number}
   * @memberof NotificationCounts
   */
  unread: number
  /**
   * Все
   * @type {number}
   * @memberof NotificationCounts
   */
  all: number
}

/**
 * Check if a given object implements the NotificationCounts interface.
 */
export function instanceOfNotificationCounts(
  value: object
): value is NotificationCounts {
  if (!('read' in value) || value['read'] === undefined) return false
  if (!('unread' in value) || value['unread'] === undefined) return false
  if (!('all' in value) || value['all'] === undefined) return false
  return true
}

export function NotificationCountsFromJSON(json: any): NotificationCounts {
  return NotificationCountsFromJSONTyped(json, false)
}

export function NotificationCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NotificationCounts {
  if (json == null) {
    return json
  }
  return {
    read: json['read'],
    unread: json['unread'],
    all: json['all'],
  }
}

export function NotificationCountsToJSON(
  value?: NotificationCounts | null
): any {
  if (value == null) {
    return value
  }
  return {
    read: value['read'],
    unread: value['unread'],
    all: value['all'],
  }
}
